const vehicleNotRegisteredSitecoreId = 'e5228779-8b3c-4066-b253-cecffa9bf26e';
const noLongerOwnVehicleSitecoreId = '333b97c3-c0a3-4127-965e-857a8b830974';
const otherReasonSitecoreId = 'fe821d42-6533-4656-9d30-bde9431c245f';
export const reasonCodes = {
  vehicleNotRegisteredSitecoreId,
  noLongerOwnVehicleSitecoreId,
  otherReasonSitecoreId,
};
